import Page     from '@app/templates/vuejs/pages/SectionPage.vue'
import factory  from '@core/vuejs/services/client.factory.service'
import {registerCommonsComponents} from '@app/assets/js/vue/components/partials/commons'
import {registerSectionComponents} from '@app/assets/js/vue/components/partials/section'
import {registerArticleComponents} from '@app/assets/js/vue/components/partials/articles'
import SectionStore from "@core/vuejs/js/store/section.store";

const componentsToRegister = [registerCommonsComponents, registerSectionComponents, registerArticleComponents]

const bundle = factory.createApp(Page, '#app', componentsToRegister, SectionStore)

export default bundle
